import { Expose, plainToClass, Type } from "class-transformer";

export interface IAirportLounge {
  id: number;
  city: string;
  country: string;
  countryCode: string;
  airportName: string;
  airportCode: string;
  terminal: string;
  terminalCode: string;
  location: string;
  loungeName: string;
  loungeCode: string;
  openingHours: string;
  additional: string;
  conditions: string;
  images: Array<IAirportLoungeImage>;
}

export interface IAirportLoungeImage {
  url: string;
  width: number;
  height: number;
  altText: string;
  contentType: string;
}

export class AirportLoungeImage implements IAirportLoungeImage {
  url: string;
  width: number;
  height: number;
  altText: string;
  contentType: string;
}

export class AirportLounge implements IAirportLounge {
  @Expose() id: number;
  @Expose() city: string;
  @Expose() country: string;
  @Expose() countryCode: string;
  @Expose() airportName: string;
  @Expose() airportCode: string;
  @Expose() terminal: string;
  @Expose() terminalCode: string;
  @Expose() location: string;
  @Expose() loungeName: string;
  @Expose() loungeCode: string;
  @Expose() openingHours: string;
  @Expose() additional: string;
  @Expose() conditions: string;

  @Type(() => AirportLoungeImage)
  @Expose()
  images: AirportLoungeImage[];
}

export function transformToAirportLoungeClass(airportLounge: IAirportLounge): AirportLounge {
  return plainToClass(AirportLounge, airportLounge);
}
